import axiosPlataformaClient from '../../../plugins/axios.plataforma.plugin';

export default {
  getTaskContent({ enrollmentId, topicId }) {
    return axiosPlataformaClient.custAxios().get(`/content/enrollment/${enrollmentId}/discursive/${topicId}`);
  },
  sendTaskAnswer({ enrollmentId, topicId, data }) {
    return axiosPlataformaClient.custAxios().post(`/content/enrollment/${enrollmentId}/discursive/${topicId}`, data);
  }
};
